import { QueryClientProvider } from '@tanstack/react-query';
import { LoadScript, useJsApiLoader } from '@react-google-maps/api';
import { Spinner } from '@kolking/react-ui';
import {
  Outlet,
  Route,
  RouterProvider,
  createBrowserRouter,
  createRoutesFromElements,
} from 'react-router-dom';

import HomePage from './pages/Home/HomePage';
import SuccessPage from './pages/Success/SuccessPage';

import { ConfigProvider } from './components/Config';
import { Layout } from './components/Layout';
import { queryClient } from './services';

import styles from './app.module.scss';

const gmapConfig: Parameters<typeof useJsApiLoader>[0] = {
  id: 'google-map-script',
  googleMapsApiKey: 'AIzaSyAkRx5-j2vEGygjw2Rp-az_OKAi1MmmvEQ',
  libraries: ['geometry', 'places'],
};

const router = createBrowserRouter(
  createRoutesFromElements(
    <Route path="/" element={<Outlet />}>
      <Route index element={<HomePage />} />
      <Route path="success" element={<SuccessPage />} />
    </Route>,
  ),
);

function App() {
  return (
    <QueryClientProvider client={queryClient}>
      <ConfigProvider>
        <LoadScript
          {...gmapConfig}
          loadingElement={
            <Layout>
              <section className={styles.loader}>
                <Spinner size="3em" />
              </section>
            </Layout>
          }
        >
          <RouterProvider router={router} future={{ v7_startTransition: true }} />
        </LoadScript>
      </ConfigProvider>
    </QueryClientProvider>
  );
}

export default App;
